$(document).ready(() => {
  
  if($('.js-feature-list').length) {

    $('.js-feature-list li').hover((e) => {

      let index = $(e.currentTarget).index();

      $('.js-feature-list').addClass('active');
      $('.js-feature-points').addClass('active');

      $('.js-feature-list li').removeClass('active');
      $(e.currentTarget).addClass('active');

      $('.js-feature-points span').removeClass('active');
      $($('.js-feature-points span')[index]).addClass('active');

    }, (e) => {

      $('.js-feature-list li').removeClass('active');
      $('.js-feature-points span').removeClass('active');

      $('.js-feature-list').removeClass('active');
      $('.js-feature-points').removeClass('active');

    });

  }

  if($('.js-feature-points').length) {

    $('.js-feature-points span').hover((e) => {

      let index = $(e.currentTarget).index();

      console.log('point on')

      $('.js-feature-list').addClass('active');
      $('.js-feature-points').addClass('active');

      $('.js-feature-points span').removeClass('active');
      $(e.currentTarget).addClass('active');

      $('.js-feature-list li').removeClass('active');
      $($('.js-feature-list li')[index]).addClass('active');

    }, (e) => {

      console.log('point off')

      $('.js-feature-list li').removeClass('active');
      $('.js-feature-points span').removeClass('active');

      $('.js-feature-list').removeClass('active');
      $('.js-feature-points').removeClass('active');

    });

  }

});